import { render } from "./News.vue?vue&type=template&id=2505475a&scoped=true"
const script = {}

import "./News.vue?vue&type=style&index=0&id=2505475a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2505475a"]])

export default __exports__